module.exports = __webpack_public_path__ + "static/media/pool-live-detail-ss.6dba06a8.png";